import { Directive, HostListener, ElementRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[textOnly]',
})
export class TextValidationDirective {
  el = inject<ElementRef<HTMLInputElement>>(ElementRef);

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const INPUT = event.target as HTMLInputElement;

    const INITIAL_VAL = INPUT.value;
    INPUT.value = INITIAL_VAL.replace(/[^a-zA-Z ]/g, '');

    if (INITIAL_VAL !== INPUT.value) {
      event.stopPropagation();
    }
  }
}
